import { toJS } from 'mobx';
import { inComeTypesObject, incomeTypesWithNckObject } from '../../helpers/PortfolioProject/IncomeHelper';
import { nckPortfolio } from '../../helpers';
import { BaseRequests } from '../BaseRequests';

export class IncomesRequests extends BaseRequests {
    #store
    #api
    #addToast
    #projId
    #portfolioId
    #stratId
    constructor({api,addToast,store,projId,portfolioId,stratId}) {
        super()
        this.#api = api
        this.#addToast = addToast
        this.#store = store
        this.#projId = projId ?  Number(projId) : projId
        this.#portfolioId = portfolioId ? Number(portfolioId) : portfolioId
        this.#stratId = Number(stratId)
    }

    #checkSelectValues = () => {
      function findEmptySelectors(selectorObject) {
        if (!this.#store.formObject[selectorObject.selectorName]) {
          this.#store.updateSelectorsClassPrefix(selectorObject.selectorName, 'reactselect-invalid__control ');
          selectorObject.status = false;
        }
      }

      if (Number.isNaN(this.#store.formObject.salesVolume)
              || this.#store.formObject.salesVolume < 0
              || this.#store.formObject.salesVolume?.toString()?.includes('e')
              || this.#store.formObject.salesVolume?.toString()?.includes('-')
      ) {
        return [{
          status: false,
          func: () => this.#addToast.error('В поле "Объем реализации за отчетный год" необходимо ввести число.'),
        }];
      }

      const statusSelectors = [
        { selectorName: 'head', status: true },
        { selectorName: 'institute', status: true },
        { selectorName: 'type', status: true },
        { selectorName: 'year', status: true },
      ];

      const findEmptySelectorsBinded = findEmptySelectors.bind(this);
      statusSelectors.forEach((value) => findEmptySelectorsBinded(value));
      return statusSelectors;
    };

  #checkInputFormValues(event, formEl) {
    const form = event?.currentTarget;
    if (form?.checkValidity() === false || (formEl.current.checkValidity() === false)) {
      const invalidEl = formEl?.current.querySelector(':invalid');
      invalidEl?.scrollIntoView({ block: 'center', behavior: 'smooth' });

      return false;
    }
    return true;
  }

  getIncomeById = (id) => this.#api.get(`/factdata/incomes/${id}`);

  getAllIncomes = () => {
    const url = BaseRequests.getUrlSearch('/factdata/incomes', {
      projId: this.#projId,
      portfId: this.#portfolioId,
      year: this.#store.filters?.year,
      status: this.#store.filters.status?.value,
    });
    const allTable = this.#api
      .get(url).then((x) => {
        this.#store.updateAllIncomes(x);
      });
    return allTable;
  };

  getAllPortfolioInComes = () => {
    const url = BaseRequests.getUrlSearch('/factdata/incomes', {
      portfId: this.#portfolioId,
      year: this.#store.filters?.year,
      status: this.#store.filters.status?.value,
    });
    const allTable = this.#api
      .get(url).then((x) => {
        this.#store.updateAllIncomes(x);
      });
    return allTable;
  };

  saveIncome = (id, event, formEl, callbackValidation) => {
    event?.preventDefault();
    event?.stopPropagation();

    const checkSelectResults = this.#checkSelectValues().every((x) => {
      if (x?.func) x.func();
      return !!x.status;
    });
    if (!checkSelectResults || !this.#checkInputFormValues(event, formEl)) {
      callbackValidation(true);
      return;
    }

    const body = {
      id,
      projId: this.#projId,
      topic: this.#store.formObject.topic,
      topicNum: this.#store.formObject.topicNum,
      type: this.#store.formObject.type.label ?? this.#store.formObject.type,
      year: this.#store.formObject.year.label ?? this.#store.formObject.year,
      customer: this.#store.formObject.customer,
      salesVolume: this.#store.formObject.salesVolume,
      institute: this.#store.formObject.institute.label ?? this.#store.formObject.institute,
      headId: this.#store.formObject.head.id,
    };

    const result = this.#api.post('/factdata/incomes', body,true);
    result
      .then((res) => this.getIncomeById(res.id))
      .then((x) => this.#store.setFormObject(x.income))
      .then(() => callbackValidation(true))
      .then(() => this.#addToast.success('Информация о доходе была сохранена'))
      .catch((err) => this.#addToast.error(err));
  };

  deleteIncomeById = async (id) => {
    const result = await this.#api.del(`/factdata/incomes/${id}`);
    if (result && !result.error) {
      const inc = [...toJS(this.#store.allIncomes.data)].filter((i) => i.id !== id);
      this.#addToast.success('Информация о доходе была удалена');
      return this.#store.updateAllIncomes({ data: inc, count: inc.length });
    }
  };

  sendIncome = async (id) => {
    const result = await this.#api.post(`/factdata/incomes/${id}/send`);
    if (result && !result.error) {
      if (this.#store.formObject) this.#store.updateFormObject('onApprove', 'status');
      const inc = [...toJS(this.#store.allIncomes.data)];
      const i = inc.find((t) => t.id === id);
      i.status = result.status;
      this.#addToast.success('Объем доходов отправлен на согласование');
      return this.#store.updateAllIncomes({ data: inc, count: inc.length });
    }
  };

  rejectIncome = async (id, comment) => {
    const result = await this.#api.post(`/factdata/incomes/${id}/reject`, { comment });
    if (result && !result.error) {
      const inc = [...toJS(this.#store.allIncomes.data)];
      const i = inc.find((t) => t.id === id);
      i.status = result.status;
      i.comment = result.comment;
      this.#addToast.success('Объем доходов не согласован');
      return this.#store.updateAllIncomes({ data: inc, count: inc.length });
    }
  };

  approveIncome = async (id) => {
    const result = await this.#api.post(`/factdata/incomes/${id}/approve`);
    if (result && !result.error) {
      const inc = [...toJS(this.#store.allIncomes.data)];
      const i = inc.find((t) => t.id === id);
      i.status = result.status;
      i.comment = null;
      this.#addToast.success('Объем доходов согласован');
      return this.#store.updateAllIncomes({ data: inc, count: inc.length });
    }
  };

  getTeamMembers = async (inputValue, callback) => {
    if (!inputValue || inputValue.length < 3) {
      return callback([]);
    }
    const year = this.#store.filters?.date ? `&year=${this.#store.filters?.date}` : '';
    const result = await this.#api.get(`/factdata/teammemberssearch?projId=${this.#projId}&portfId=${this.#portfolioId}${year}&name=${inputValue.trim()}`);
    callback(this.#mapOptionsToValuesOnMembers(result));
  };

  #mapOptionsToValuesOnMembers = (options) =>
  // value, label, isFixed, isDisabled
    options.map((option) => ({
      id: option.id,
      label: `${option.lastName || ''} ${option.firstName || ''} ${option.middleName || ''} (${option.post || 'должность не указана'})`,
      user: option,
    }));

  getInstitutes = (inputValue, callback) => {
    const result = toJS(this.#store?.allInstitutes);
    if (result) {
      if (!callback) { return this.#mapOptionsToValuesOnInstitutes(result); }
      callback(this.#mapOptionsToValuesOnInstitutes(result, inputValue));
    }
  };

  #mapOptionsToValuesOnInstitutes = (options, inputValue) =>
  // value, label, isFixed, isDisabled
    !!options
        ? options?.filter((option) => !inputValue && option.title.includes(inputValue)).map((option) => ({
      value: option.id,
      label: option.title,
    }))
        : [];

  getIncomeTypes = (inputValue, callback) => {
    const result = (nckPortfolio.stratId === this.#stratId && nckPortfolio.portfId === this.#portfolioId) ? incomeTypesWithNckObject : inComeTypesObject;
    if (!callback) { return this.#mapOptionsToValuesOnTypes(result); }
    callback(this.#mapOptionsToValuesOnTypes(result, inputValue));
  };

  #mapOptionsToValuesOnTypes = (options, inputValue) => {
    // value, label, isFixed, isDisabled
    const filtered = options.filter((option) => !inputValue || option.incomeTitle.toUpperCase().includes(inputValue.toUpperCase())).map((option) => ({
      value: option.id,
      label: option.incomeTitle,
    }));
    return options.filter((option) => !inputValue || option.incomeTitle.toUpperCase().includes(inputValue.toUpperCase())).map((option) => ({
      value: option.id,
      label: option.incomeTitle,
    }));
  };
}
